import accountsQuickform  from "./accounts-quickform.html";

const quickformEntity      = require ('../../../../../components/quickform/quickform-entity')
const quickformHandler     = require ('../../../../../components/quickform/quickform-handler')
const quickformForm        = require ('../../../../../components/quickform/quickform-form')
const {formCopy}           = require('./accounts-quickform-form')
const {form}               = require('./accounts-quickform-form')
const {accountTypeOptions} = require('./accounts-quickform-form')
const autocomplete         = require ('../../../../../components/textfield/autocomplete')
const textfieldMultiselect = require ('../../../../../components/textfield/textfield-multiselect')
const snack                = require ('../../../../../components/snack/snack')
const dbRequest            = require ('../../../../../js-network/db-request')
const inf                  = require ('../../../../../js-network/inf')
const websocket            = require ('../../../../../js-network/web-socket')

/****************ELEMENTS*****************/
var htmlQf   = {}
var HTMLwasSelected = false
var saving = false

function HTMLselect(detail){


	quickformHandler.HTMLselect(

            'accounts', //database table name
            'accounts-quickform',
            detail.ev.target, //source autocomplete
             accountsQuickform,
             form,
             formCopy,
             htmlQf)

	HTMLwasSelected   = true


}/**/

export function start(detail){

      if(saving) { return }
      if(!HTMLwasSelected && detail.act !== 'prepareAdd') { return }
      if(!HTMLwasSelected) { HTMLselect(detail) }
      if(detail.act === 'prepareAdd') { htmlQf.source = detail.ev.target }

      obj[detail.act].start(detail)
}/**/

const obj = {

      addOne:           { start: (detail)=>{  addOne(detail, htmlQf)                      }},
      hide:             { start: (detail)=>{  quickformEntity.hide(detail, htmlQf)        }},
      prepareAdd:       { start: (detail)=>{  prepareAdd(detail, htmlQf)                  }},

}/**/

async function addOne(detail, htmlQf) {
  const source = htmlQf.autocomplete

  if (!htmlQf.quickformHTML.classList.contains('quickform-show') || !sourceIsEditable(source)) return

  quickformForm.getValues(htmlQf)

  if (quickformForm.checkRequired(htmlQf)) return

  const typeField = form.find((field) => field.name === 'type')

  if (!typeField.options.some((option) => option.value === typeField.value)) {
    textfieldMultiselect.error(typeField.html)
    return
  }

  inf.toInsert(detail, htmlQf)
  saving = true

  try {
    // El postguardado generico solo reabre la lista. Aqui seleccionamos la respuesta
    // del insert sin lanzar esa busqueda ni modificar el quickform compartido.
    const result = await dbRequest.start(detail, 'server/php/sql/insert.php')
    if (
      result.status !== 'ok'
      || (result.restriction && result.restriction.val !== 'ok')
      || !result.data?.[0]?.id
    ) {
      snack.start({ act: 'show', id: 'addError' })
      return
    }

    const account = result.data[0]

    if (sourceIsEditable(source)) {
      autocomplete.start({ act: 'clean', html: source })
      autocomplete.start({
        act: 'select',
        parent: source.id,
        id: String(account.id),
        displayText: escapeHtml(`${account.name} - ${account.balance}`),
        otherField: {},
      })
    }

    quickformEntity.hide(detail, htmlQf)
    snack.start({ act: 'show', id: 'addOk' })
    websocket.entityUpdate(
      'entityUpdate',
      'addRow',
      { ...account, dest: 'accounts' },
      { to: 'allStaff', from: 'staffDesktop', id: '' },
    )
  } catch (error) {
    snack.start({ act: 'show', id: 'addError' })
  } finally {
    saving = false
  }
}

function sourceIsEditable(source) {
  const fullcont = source?.closest('.fullcont')

  return fullcont?.classList.contains('fullcont-show')
    && !fullcont.classList.contains('mode-readOnly')
    && (fullcont.classList.contains('mode-add') || fullcont.classList.contains('mode-edit'))
    && !source.closest('[data-transaction-section]')?.classList.contains('dn')
}

function prepareAdd(detail, htmlQf) {
  const source = detail.ev.target.parentElement.querySelector('.textfield-autocomplete')
  if (!sourceIsEditable(source)) return

  // Usa el mismo filtro que consulta las cuentas del autocomplete de origen.
  const inputDetail = JSON.parse(source.querySelector('input').getAttribute('data-detail'))
  const filter = inputDetail.click.find((action) =>
    action.dest === 'autocomplete' && action.entity === 'account_type'
  )?.acMoreData
  const filterIndex = filter?.fields.indexOf('accountTypes')

  if (filterIndex === undefined || filterIndex < 0) return

  const allowedTypes = JSON.parse(filter.values[filterIndex])

  if (!Array.isArray(allowedTypes)) return

  const options = accountTypeOptions.filter((option) =>
    allowedTypes.length === 0 || allowedTypes.includes(option.value)
  )

  if (options.length === 0) return

  htmlQf.autocomplete = source

  const typeField = form.find((field) => field.name === 'type')

  typeField.options = options
  formCopy.find((field) => field.name === 'type').options = options

  autocomplete.start({ act: 'hide' })
  quickformEntity.prepareAdd(detail, htmlQf)
}

// El generador de chips usa HTML tanto en el texto como en el atributo title.
function escapeHtml(value) {
  return String(value).replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }[character]))
}
